// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconSearch = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M15.192 16.606a7 7 0 111.414-1.414l3.601 3.601-1.414 1.414zM16 11a5 5 0 11-10 0 5 5 0 0110 0"
    />
  );
export default SvgIconSearch;
